import { useEffect } from "react";

export const useWillUnmount = (callback: () => void): void => {
    useEffect(
        () => () => {
            callback();
        },
        [],
    );
};
